import { useTranslation } from "react-i18next";

const PageLoader = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-cream px-6">
      <div className="flex w-full max-w-sm flex-col items-center text-center">
        <img src="/logo.webp" alt="DEM Properties" className="w-40 sm:w-48" width={208} height={90} />
        <div className="mt-10 h-px w-44 overflow-hidden bg-[#E4D9CB]" aria-hidden="true">
          <div className="dem-loader-bar h-full bg-[#a26850]" />
        </div>
        <p className="mt-6 font-oswald text-[11px] uppercase leading-relaxed tracking-[0.28em] text-stone-500">
          {t("home.loading")}
        </p>
      </div>
    </div>
  );
};

export default PageLoader;
